import {Spin} from "antd";

export default function FullLoader({show}){

    return (
        <>
            {show && (
                <div className="loading">
                    <Spin size="large" />
                </div>
            )}
        </>

    )
}
